import feedBack from './feedBack.vue';

export default feedBack;
